function checkOutOfStock () {
    const bisWidget = document.querySelector(".backinstock-subscription_wrapper");
    if (!bisWidget) return;
    document.addEventListener("variant:changed", e => {
      const variant = e.detail.variant;
      if (!e.target.contains(bisWidget)) return;
      const appstleWidget = document.querySelector(".appstle-widget-container") ?? {style: { display: "" } }
      if (variant && !variant.available) {
        bisWidget.style.display = "block";
        appstleWidget.style.display = "none";
      } else {
        bisWidget.style.display = "none"
        appstleWidget.style.display = "block";
      }
    })
  }
checkOutOfStock ()
